import { useEffect, useLayoutEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { hasPermission } from "Components/Utilities";
import history from "../history";
import {
  createPersonalSettings,
  fetchCompanyLocations,
  fetchPersonalSettings,
  fetchPersonalDisplaySettings,
  fetchStandardDisplaySettings,
  fetchPersonsMinimal,
  fetchReminders,
  fetchReminderCategories,
  setLoggedUser,
  setLocationId,
  fetchRolls,
  fetchDepartmentsMinimal,
  fetchUnpublishedDays,
  fetchTimes,
  fetchCurrentStats,
  fetchSomuraStart,
  dataReset,
} from "../redux/index";
import { developerMail } from "Constants";
import { DateTime, Settings } from "luxon";
import { jwtDecode } from "jwt-decode";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { languages } from "Constants";
import store from "../redux/store";
import { Box } from "@mui/material";
import { getGlobalSetting, getPersonalSetting } from "Components/Utilities";
import SomuraTooltip from "Components/SomuraTooltip";
import LocationSelection from "Components/LocationSelection";

import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import DashboardTwoToneIcon from "@mui/icons-material/DashboardTwoTone";
import MonthCalIcon from "@mui/icons-material/TodayTwoTone";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import DateRangeIcon from "@mui/icons-material/DateRangeTwoTone";
import PersonsIcon from "@mui/icons-material/PeopleTwoTone";
import TimeTrackIcon from "@mui/icons-material/TimerOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import DevicesIcon from "@mui/icons-material/Devices";

import ReplayIcon from "@mui/icons-material/Replay";
import NewsBadge from "./NewsBadge.js";
import TimeFaultyBadge from "./TimeFaultyBadge.js";
import UnpublishedDaysBadge from "./UnpublishedDaysBadge.js";
import UnpublishedDays from "./UnpublishedDays";
import RemindersBadge from "./RemindersBadge.js";
import TasksBadge from "./TasksBadge.js";
import RemindersAlert from "./RemindersAlert.js";
import Reminder from "./Reminder.js";
// import { sendMailNotification } from "Components/Utilities";

import SettingsMenu from "./SettingsMenu";
import UserMenu from "./UserMenu";
import LanguageMenu from "./LanguageMenu";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Snackbar from "@mui/material/Snackbar";
import SomuraAlert from "Components/SomuraAlert";
import ShowTime from "./ShowTime";

import RemindersDialog from "Reminders/RemindersDialog";
import GameDialog from "Components/Game/GameDialog";

const drawerWidth = 240;
const appBarHeight = 64;

const mapStateToProps = (state) => {
  return {
    dataError: state.general.dataError,
    dataSuccess: state.general.dataSuccess,
    dataLoading: state.general.dataLoading,
    actionSuccess: state.general.actionSuccess,
    error: state.general.error,
    loggedUser: state.loggeduser.LoggedUser,
    rolls: state.security.Rolls,
    globalSettings: state.settings.GlobalSettings,
    unpublishedDays: state.unpublisheddays.UnpublishedDays,
    reminders: state.reminders.Reminders,
    showMessage: state.general.showMessage,
    showReminderDate: state.reminders.showReminderDate,
    selectedLocation: state.selections.selectedLocationId,
    stats: state.general.Stats,
    locations: state.company.Locations,
    unreadMessages: state.general.Stats.numUnread,
    persons: state.persons.PersonsMin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createPersonalSettings: (id) =>
      dispatch(createPersonalSettings({ userId: id })),
    setLoggedUser: (id) => dispatch(setLoggedUser({ id: id })),
    setLocationId: (values) => dispatch(setLocationId(values)),
    fetchRolls: (values) => dispatch(fetchRolls(values)),
    fetchCompanyLocations: async () => dispatch(fetchCompanyLocations()),
    fetchPersonalSettings: (id) =>
      dispatch(fetchPersonalSettings({ userId: id })),
    fetchPersonalDisplaySettings: (id) =>
      dispatch(fetchPersonalDisplaySettings({ userId: id })),
    fetchStandardDisplaySettings: () =>
      dispatch(fetchStandardDisplaySettings()),
    fetchPersonsMinimal: (values) => dispatch(fetchPersonsMinimal(values)),
    fetchReminders: (values) => dispatch(fetchReminders(values)),
    fetchReminderCategories: (values) =>
      dispatch(fetchReminderCategories(values)),
    fetchDepartmentsMinimal: async () => dispatch(fetchDepartmentsMinimal()),
    fetchUnpublishedDays: (id) =>
      dispatch(fetchUnpublishedDays({ userId: id })),
    fetchTimes: async (values) => dispatch(fetchTimes(values)),
    fetchCurrentStats: async (values) => dispatch(fetchCurrentStats(values)),
    fetchSomuraStart: () => dispatch(fetchSomuraStart()),
    dataReset: () => dispatch(dataReset()),
  };
};

const MainMenu = ({
  loggedUser,
  reminders,
  fetchCurrentStats,
  fetchSomuraStart,
  ...props
}) => {
  const { t, i18n } = useTranslation();
  // const selectedLocation = useSelector((state) => state.selections);
  const [loggedUserId, setLoggedUserId] = useState("");
  const [open, setOpen] = useState(false);
  const [openReminder, setOpenReminder] = useState(false);
  const [openUnpublishedDays, setUnpublishedDays] = useState(false);
  const [disableMessages, setDisableMessages] = useState(false);
  const [useTimeTracking, setUseTimeTracking] = useState(false);
  const [useArticles, setUseArticles] = useState(false);
  const [useRooms, setUseRooms] = useState(false);
  const [alertReminders, setAlertReminders] = useState([]);
  const [todayReminders, setTodayReminders] = useState([]);
  const [todayTasks, setTodayTasks] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [openGame, setOpenGame] = useState(false);
  // const myReminders = useRef(reminders);
  const timeRef = useRef();
  const today = DateTime.now();

  const favLink = document.querySelector("link[rel~='icon']");
  const touchLink = document.querySelector("link[rel~='apple-touch-icon']");

  const multilingual =
    parseInt(getGlobalSetting("language", "multilingual")) === 1;
  const useWebTerminal =
    parseInt(getGlobalSetting("timetracking", "useWebTerminal")) === 1;
  const useMonthCalendar =
    parseInt(getPersonalSetting("calendars", "useMonthCalendar")) === 1 || true;
  const useYearCalendar =
    parseInt(getPersonalSetting("calendars", "useYearCalendar")) === 1 || true;
  const useCustomerCalendar =
    parseInt(getPersonalSetting("calendars", "useCustomerCalendar")) === 1 ||
    false;
  const showReminders =
    parseInt(getPersonalSetting("reminders", "showReminders")) === 1 || true;
  const maxClientWidth = parseInt(
    getPersonalSetting("general", "maxClientWidth"),
  );
  const clientPosition = parseInt(
    getPersonalSetting("general", "clientPosition"),
  );
  const loggedUserIsDeveloper = useRef(false);
  const showAllDepartments = hasPermission("showAllDepartments");

  let numUnpublished = 0;
  if (props.unpublishedDays.length > 0) {
    numUnpublished = props.unpublishedDays.reduce(function (prev, act) {
      return prev + parseFloat(act.numDays);
    }, 0);
  }

  const menuItemClick = (name) => () => {
    store.dispatch({
      type: "DISABLE_LOCATION_SELECTION",
      payload: false,
    });
    store.dispatch({
      type: "OPEN_USER_STATS",
      payload: false,
    });
    store.dispatch({
      type: "SET_PERSON_ID",
      payload: -1,
    });
    localStorage.setItem("lastPage", name);
    setOpen(false);
    if (name === "Reminders") {
      store.dispatch({
        type: "SET_DISPLAY_REMINDER",
        payload: {
          reminders: reminders.filter(
            (R) =>
              DateTime.fromSQL(R.date)
                .startOf("day")
                .diff(DateTime.now().startOf("day"), "days")
                .toObject().days <= 0,
          ),
        },
      });
      store.dispatch({
        type: "OPEN_REMINDER_DIALOG",
        payload: {
          calendar: "",
          date: DateTime.now().toSQLDate(),
          mode: "E",
        },
      });
    }
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleUDClose = () => {
    setUnpublishedDays(false);
  };

  const handleUDOpen = () => {
    setUnpublishedDays(true);
  };

  const handleSnackClose = () => {
    props.dataReset();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseReminder = () => {
    setOpenReminder(false);
    favLink.href = "../images/somura-favicon_light_512.svg";
    touchLink.href = "../images/somura-favicon_light_512.svg";
  };

  const handleReloadClick = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    window.location.reload(true);
  };

  const handleGame = (e) => {
    e.preventDefault();
    setOpenGame(true);
  };

  const updateData = () => {
    if (showReminders) {
      fetchCurrentStats({
        userId: localStorage.getItem("userId"),
        locationId: localStorage.getItem("location"),
        departmentId: hasPermission("seeAllDepartments")
          ? 0
          : loggedUser?.departmentId,
      });
    }
    setAlertReminders(props.stats.numReminders);
    setTodayReminders(props.reminders);
    setTodayTasks(props.stats.numDueTasks);
  };

  useEffect(() => {
    updateData();
    fetchSomuraStart();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Fetch the rolls
    props.fetchRolls({ locationId: props.selectedLocation });
    // eslint-disable-next-line
  }, [props.selectedLocation]);

  // THIS NEEDS TO BE REPROGRAMMED
  // -> Shows up too often!
  // useEffect(() => {
  //   if (props.unreadMessages > 0) {
  //     sendMailNotification(
  //       t("You have") +
  //         " " +
  //         props.unreadMessages +
  //         " " +
  //         t(props.unreadMessages === 1 ? "unread message" : "unread messages") +
  //         "."
  //     );
  //   }
  // }, [props.unreadMessages, t]);

  useEffect(() => {
    setAlertReminders(props.stats.numReminders);
    setTodayTasks(props.stats.numDueTasks);
  }, [props.stats]);

  useEffect(() => {
    if (props.stats.numAlerts > 0) {
      // Change favicon
      // favLink.href = "../images/somura-favicon_light_reminder.svg";
      // touchLink.href = "../images/somura-favicon_light_reminder.svg";
      // setOpenReminder(true);
    }
  }, [props.stats.numAlerts]);

  useEffect(() => {
    if (localStorage.jwt) {
      const token = localStorage.getItem("jwt");
      const tokenId = jwtDecode(token).uid;
      setLoggedUserId(tokenId);
    }
    // eslint-disable-next-line
  }, [localStorage.jwt]);

  useEffect(() => {
    if (props.globalSettings) {
      if (
        props.globalSettings["system"]?.settings["useMessageModule"] === "1"
      ) {
        updateData();
      }
    }
    setDisableMessages(
      props.globalSettings["system"]?.settings["useMessageModule"] !== "1",
    );
    setUseTimeTracking(
      useWebTerminal &&
        props.globalSettings["system"]?.settings["useTimeTrackModule"] === "1",
    );
    setUseArticles(
      props.globalSettings["system"]?.settings["useArticlesModule"] === "1",
    );
    setUseRooms(
      props.globalSettings["system"]?.settings["useRoomsModule"] === "1",
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.globalSettings]);

  useEffect(() => {
    // Get basic persons information
    if (loggedUser.companyId !== undefined) {
      if (loggedUser.changePW) {
        history.push("/changepw");
      }
      fetchCurrentStats({
        userId: loggedUser?.id,
        locationId: loggedUser?.companyId,
        departmentId: hasPermission("seeAllDepartments")
          ? 0
          : loggedUser?.departmentId,
      });
      // Set default for selected user
      store.dispatch({
        type: "SET_DISPLAY_USER",
        payload: loggedUser.isDeveloper ? props.persons[0]?.id : loggedUser.id,
      });
      // Set already stored location ID
      props.setLocationId(loggedUser.companyId);
      localStorage.setItem("location", loggedUser.companyId);
      props.fetchPersonsMinimal({ companyId: loggedUser?.companyId });
      // Set the language of the user's company location
      const language = languages.find(
        (L) => parseInt(L.languageId) === parseInt(loggedUser.languageId),
      )?.languageName;
      i18n.changeLanguage(language);
      Settings.defaultLocale = language.substr(0, 2);
      localStorage.setItem("lang", language);
    }
    //eslint-disable-next-line
  }, [loggedUser]);

  useEffect(() => {
    if (
      Object.keys(loggedUser).length > 0 &&
      Object.keys(props.rolls).length > 0
    ) {
      loggedUserIsDeveloper.current = props.rolls.find(
        (R) => R.id === loggedUser.rollId,
      )?.isDeveloper;
    }
    //eslint-disable-next-line
  }, [props.rolls]);

  useLayoutEffect(() => {
    // Set language
    const localLanguage = localStorage.getItem("lang");
    if (
      localLanguage &&
      localLanguage !== "undefined" &&
      localLanguage !== ""
    ) {
      i18n.changeLanguage(localLanguage);
      Settings.defaultLocale = localLanguage.substr(0, 2);
    } else {
      var defaultLanguage = getGlobalSetting("language", "systemLanguage");
      if (!defaultLanguage) {
        defaultLanguage = "de-DE";
      }
      i18n.changeLanguage(defaultLanguage);
      Settings.defaultLocale = defaultLanguage.substr(0, 2);
      localStorage.setItem("lang", defaultLanguage);
    }
    // const token = localStorage.getItem("jwt");
    if (loggedUserId !== "") {
      const userid = loggedUserId;
      // Set logged user
      props.setLoggedUser(userid);

      // Create personal settings if needed
      props.createPersonalSettings(userid);
      // Get company data
      props.fetchCompanyLocations();
      // Get company departments
      props.fetchDepartmentsMinimal();
      // Get settings of user
      props.fetchPersonalSettings(userid);
      props.fetchPersonalDisplaySettings(userid);
      props.fetchStandardDisplaySettings();
      // Get tracked time of logged person
      props.fetchTimes({
        userId: userid,
        month: today.month,
        year: today.year,
      });
      // Fetch reminders
      props.fetchReminders({
        userId: userid,
        categoryId: -1,
        startDate: DateTime.now().startOf("month").toFormat("yyyy-MM-dd"),
        endDate: DateTime.now().endOf("month").toFormat("yyyy-MM-dd"),
      });
      props.fetchReminderCategories({ userId: userid });
      // Get unpublished days
      props.fetchUnpublishedDays(userid);
      // Reset state
      store.dispatch({ type: "SET_EDIT_MODE", payload: false });
      store.dispatch({ type: "SET_SELECTED_WORKDAYS", payload: 0 });
      store.dispatch({ type: "SET_SELECTED_CALENDARDAYS", payload: 0 });
      store.dispatch({ type: "SET_SELECTED_DAYS", payload: [] });
      store.dispatch({ type: "SET_PERSON_ID", payload: -1 });
      store.dispatch({ type: "SET_SELECTED_TIME_FORM_ID", payload: -1 });
      // Stats are getting fetched all over the place. There is literally no need to have an interval for this.
      // TODO: Remove.
      // WR: updateData() is used to set the alive-time and check for reminders
      timeRef.current = setInterval(() => {
        updateData();
      }, 30000);

      if (history.goBack.length === 0 && history.location.pathname === "/") {
        const startPage = localStorage.getItem("startPage");
        const lastPage = localStorage.getItem("lastPage") || "";
        if (lastPage.length > 0 && lastPage !== "undefined") {
          history.push("/" + lastPage);
        } else if (startPage?.length > 0) {
          if (
            startPage === "MonthCalendar" &&
            hasPermission("showMonthCalendar")
          ) {
            history.push("/MonthCalendar");
          } else {
            history.push("/" + startPage);
          }
        } else {
          history.push("/");
          localStorage.setItem("startPage", "");
        }
      }
    } else {
      history.push("/login");
    }
    setDisableMessages(
      parseInt(getGlobalSetting("system", "useMessageModule")) !== 1,
    );
    return () => {
      clearInterval(timeRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUserId]);

  return (
    <>
      <CssBaseline />
      {loggedUser.id && (
        <Drawer
          variant="permanent"
          sx={{
            flexShrink: 0,
            whiteSpace: "nowrap",
            border: "none",
            backgroundColor: "background.drawer",
            overflowX: "hidden",
            ...(open
              ? {
                  width: drawerWidth,
                  transition: (theme) =>
                    theme.transitions.create("width", {
                      easing: theme.transitions.easing.sharp,
                      duration: theme.transitions.duration.enteringScreen,
                    }),
                }
              : {
                  width: "73px",
                  transition: (theme) =>
                    theme.transitions.create("width", {
                      easing: theme.transitions.easing.sharp,
                      duration: theme.transitions.duration.leavingScreen,
                    }),
                }),
            "& .MuiPaper-root": {
              border: "none",
              backgroundColor: "background.drawer",
              ...(open
                ? {
                    width: drawerWidth,
                    transition: (theme) =>
                      theme.transitions.create("width", {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                      }),
                  }
                : {
                    transition: (theme) =>
                      theme.transitions.create("width", {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                      }),
                    overflowX: "hidden",
                    width: "73px",
                  }),
            },
          }}
        >
          <Box
            sx={{
              border: "none",
              minHeight: "50px !important",
              height: appBarHeight,
              backgroundColor: "somura",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {open ? (
              <Box
                component="img"
                sx={{
                  height: "1.8rem",
                }}
                alt="Logo"
                src="/images/Somura-logo-default_wht.svg"
              />
            ) : (
              <Box
                component="img"
                sx={{
                  height: "1.8rem",
                }}
                alt="Logo"
                src="/images/Somura-icon_wht_512.svg"
                onContextMenu={handleGame}
              />
            )}
          </Box>
          <List>
            {hasPermission("showDashboard") && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Dashboard"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("Dashboard")}
                  to={"/"}
                  key="Dashboard"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title="Dashboard" placement="right">
                    <ListItemIcon>
                      <DashboardTwoToneIcon
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary="Dashboard" />
                </ListItemButton>
              </ListItem>
            )}
            {hasPermission("showMonthCalendar") && useMonthCalendar && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="MonthCalendar"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("MonthCalendar")}
                  to={"/MonthCalendar"}
                  key="Monatskalender"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title={t("Month calendar")} placement="right">
                    <ListItemIcon>
                      <MonthCalIcon
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Month calendar")} />
                </ListItemButton>
              </ListItem>
            )}
            {useYearCalendar && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="YearCalendar"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("YearCalendar")}
                  to={"/YearCalendar"}
                  key="Jahreskalender"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title={t("Year calendar")} placement="right">
                    <ListItemIcon>
                      <DateRangeIcon
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Year calendar")} />
                </ListItemButton>
              </ListItem>
            )}
            {useCustomerCalendar && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="CustomerCalendar"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("CustomerCalendar")}
                  to={"CustomerCalendar"}
                  key="Kundenkalender"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip
                    title={t("Customer calendar")}
                    placement="right"
                  >
                    <ListItemIcon>
                      <PermContactCalendarOutlinedIcon
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Customer calendar")} />
                </ListItemButton>
              </ListItem>
            )}
            {hasPermission("showPersons") && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Persons"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("Persons")}
                  to={"/Persons"}
                  key="Mitarbeiter"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title={t("Persons")} placement="right">
                    <ListItemIcon>
                      <PersonsIcon
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Persons")} />
                </ListItemButton>
              </ListItem>
            )}
            {((!loggedUser.noTimeTracking && useTimeTracking) ||
              loggedUser.emailCompany === developerMail) && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Times"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("TimeTracking")}
                  to={"/TimeTracking"}
                  key="Zeiterfassung"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip
                    title={t(
                      hasPermission("administerPersonTimes")
                        ? "Time tracking"
                        : "Personal worktimes",
                    )}
                    placement="right"
                  >
                    <ListItemIcon>
                      {hasPermission("administerPersonTimes") ? (
                        <TimeFaultyBadge
                          sx={{
                            fontSize: "2rem",
                          }}
                        />
                      ) : (
                        <TimeTrackIcon
                          sx={{
                            fontSize: "2rem",
                          }}
                        />
                      )}
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText
                    primary={t(
                      hasPermission("administerPersonTimes")
                        ? "Time tracking"
                        : "Personal worktimes",
                    )}
                  />
                </ListItemButton>
              </ListItem>
            )}
            {!disableMessages && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Messages"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("Messages")}
                  to={"/Messages"}
                  key="Nachrichten"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip
                    title={
                      disableMessages
                        ? t("Messages are disabled")
                        : t("Messages")
                    }
                    placement="right"
                  >
                    <ListItemIcon>
                      <NewsBadge
                        sx={{
                          fontSize: "2rem",
                        }}
                      />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Messages")} />
                </ListItemButton>
              </ListItem>
            )}
            {useArticles && hasPermission("showArticles") && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Articles"
                  sx={{
                    width: "4rem",
                    height: "3rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("Articles")}
                  to={"/Articles"}
                  key="Artikel"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title={t("Articles")} placement="right">
                    <ListItemIcon>
                      <DevicesIcon />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Articles")} />
                </ListItemButton>
              </ListItem>
            )}
            {useRooms && hasPermission("seeCompanyData") && (
              <ListItem sx={{ width: "18rem", marginLeft: "-1.4rem" }}>
                <ListItemButton
                  name="Rooms"
                  sx={{
                    width: "4rem",
                    height: "4rem",
                    margin: "0.3rem",
                    borderRadius: "6px",
                  }}
                  component={NavLink}
                  exact
                  onClick={menuItemClick("Rooms")}
                  to={"/Rooms"}
                  key="Rooms"
                  activeClassName="selectedItem"
                >
                  <SomuraTooltip title={t("Rooms calendar")} placement="right">
                    <ListItemIcon>
                      <ChairOutlinedIcon />
                    </ListItemIcon>
                  </SomuraTooltip>
                  <ListItemText primary={t("Rooms calendar")} />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Drawer>
      )}

      {loggedUser.id && (
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: "somura",
            color: "white",
            display: "grid",
            gridTemplateRows: "1fr",
            gridTemplateColumns: "2rem 2rem 1fr 1fr 4rem 4rem 4rem 4rem",
            height: appBarHeight,
            marginLeft: "73px",
            width: `calc(100% - 73px)`,
            zIndex: (theme) => theme.zIndex.drawer + 1,
            transition: (theme) =>
              theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
            ...(open
              ? {
                  marginLeft: drawerWidth,
                  width: `calc(100% - ${drawerWidth}px)`,
                }
              : {}),
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            edge="start"
            sx={{
              width: "1rem",
              height: "1rem",
              margin: "auto 0 auto 0.1rem",
              gridRow: 1,
              gridColumn: 1,
            }}
            size="large"
          >
            {open ? (
              <SomuraTooltip title={t("Shrink sidebar")} placement="right">
                <ChevronLeftIcon
                  sx={{
                    width: "4rem",
                    gridRow: "1",
                  }}
                />
              </SomuraTooltip>
            ) : (
              <SomuraTooltip title={t("Expand sidebar")} placement="right">
                <ChevronRightIcon
                  sx={{
                    width: "4rem",
                    gridRow: "1",
                  }}
                />
              </SomuraTooltip>
            )}
          </IconButton>
          <SomuraTooltip title={t("Reload")} placement="right">
            <IconButton
              edge="start"
              sx={{
                width: "1rem",
                height: "1rem",
                margin: "auto 0 auto 0.1rem",
                gridRow: 1,
                gridColumn: 2,
              }}
              size="large"
              onClick={handleReloadClick}
            >
              <ReplayIcon
                sx={{
                  width: "4rem",
                  gridRow: "1",
                }}
              />
            </IconButton>
          </SomuraTooltip>
          {useTimeTracking &&
            !loggedUser.noTimeTracking &&
            !loggedUser.noWebTimeTracking && <ShowTime />}
          {hasPermission("seeAllCompanyLocations") &&
            props.locations.length > 1 && (
              <Box
                sx={{
                  gridColumn: 4,
                  borderRadius: "0.5rem",
                  boxShadow: "inset 3px 3px 3px 1px rgba(0, 0, 0, 0.4)",
                  alignSelf: "center",
                  justifySelf: "center",
                }}
              >
                <LocationSelection />
              </Box>
            )}
          <Box
            sx={{
              width: "16rem",
              gridColumn: "-2 / -5",
              display: "inline-flex",
              justifyContent: "flex-end",
            }}
          >
            {todayReminders > 0 && (
              <SomuraTooltip
                title={
                  `${todayReminders} ` +
                  (todayReminders === 1 ? t("appointment") : t("appointments"))
                }
                placement="left"
              >
                <IconButton
                  sx={{
                    width: "4rem",
                    // gridRow: "1",
                  }}
                  name="Reminders"
                  component={NavLink}
                  onClick={menuItemClick("Reminders")}
                  to={"/Reminders"}
                  edge="end"
                  aria-label="reminders"
                  aria-controls="usermenu"
                  aria-haspopup="true"
                  color="inherit"
                  size="large"
                >
                  <RemindersBadge count={todayReminders} />
                </IconButton>
              </SomuraTooltip>
            )}
            {todayTasks > 0 && (
              <SomuraTooltip
                title={
                  `${todayTasks} ` +
                  (todayTasks === 1 ? t("due task") : t("due tasks"))
                }
                placement="left"
              >
                <IconButton
                  sx={{
                    width: "4rem",
                    // gridRow: "1",
                  }}
                  name="Tasks"
                  component={NavLink}
                  onClick={menuItemClick("Tasks")}
                  to={"/Tasks"}
                  edge="end"
                  aria-label="tasks"
                  aria-controls="usermenu"
                  aria-haspopup="true"
                  color="inherit"
                  size="large"
                >
                  <TasksBadge count={todayTasks} />
                </IconButton>
              </SomuraTooltip>
            )}
            {loggedUserIsDeveloper.current && (
              <Box
                sx={{
                  position: "absolute",
                  color: "white",
                  marginTop: "2.9rem",
                  fontSize: "0.8rem",
                  backgroundColor: "#F44336",
                  borderRadius: "0.5rem",
                  height: "1rem",
                  lineHeight: "1rem",
                  padding: "0 6px",
                  zIndex: 10,
                }}
              >
                {t("Developer")}
              </Box>
            )}
            {props.unpublishedDays.length > 0 && (
              <SomuraTooltip
                title={`${numUnpublished} ` + t("unpublished days")}
                placement="left"
              >
                <IconButton
                  sx={{
                    width: "4rem",
                    // gridRow: "1",
                  }}
                  edge="end"
                  aria-label="unpublished days"
                  aria-controls="usermenu"
                  aria-haspopup="true"
                  onClick={handleUDOpen}
                  color="inherit"
                  size="large"
                >
                  <UnpublishedDaysBadge closeUnpublishedDays={handleUDClose} />
                </IconButton>
              </SomuraTooltip>
            )}

            {hasPermission("showSettingsMenu") && (
              <SettingsMenu
                sx={{
                  width: "4rem",
                  gridRow: "1",
                }}
              />
            )}
            {multilingual && (
              <LanguageMenu
                sx={{
                  width: "4rem",
                  gridRow: "1",
                }}
              />
            )}
            <UserMenu
              sx={{
                width: "4rem",
                gridRow: "1",
              }}
            />
          </Box>
        </AppBar>
      )}
      <Box
        sx={{
          width: "100%",
          maxWidth: maxClientWidth > 0 ? maxClientWidth + "vw" : "100%",
          margin:
            clientPosition === 0
              ? "54px auto 0px 0px"
              : clientPosition === 2
                ? "54px 0px 0px auto"
                : "54px auto",
        }}
      >
        {props.children}
      </Box>
      <Snackbar
        open={
          props.dataError &&
          props.error?.indexOf("Unexpected end of JSON input") === -1
        } // error is supressed because it could not be located :(
        autoHideDuration={4000}
        onClose={handleSnackClose}
      >
        <SomuraAlert
          severity="error"
          title={
            props.error ? t("Error") + ": <<" + props.error + ">>" : t("Error")
          }
          message={
            props.error
              ? props.error === "Failed to fetch"
                ? t("Data could not be loaded!")
                : t("Data was NOT processed!")
              : t("Changes were NOT processed!") + ": " + props.error
          }
        />
      </Snackbar>
      <Snackbar
        open={props.dataSuccess}
        autoHideDuration={4000}
        onClose={handleSnackClose}
      >
        <SomuraAlert
          severity="success"
          message={t("Changes were successfully saved.")}
        />
      </Snackbar>
      <Snackbar
        open={props.actionSuccess}
        autoHideDuration={4000}
        onClose={handleSnackClose}
      >
        <SomuraAlert
          severity="success"
          message={t("The action was successfully completed.")}
        />
      </Snackbar>
      {openReminder && <Reminder closeReminder={handleCloseReminder} />}
      {openUnpublishedDays === true && (
        <UnpublishedDays
          closeUnpublishedDays={() => setUnpublishedDays(false)}
        />
      )}
      {openAlert && (
        <RemindersAlert
          reminders={alertReminders}
          handleCloseDialog={handleCloseAlert}
        />
      )}
      {props.showReminderDate === "Menu" && <RemindersDialog />}
      {openGame && <GameDialog handleClose={() => setOpenGame(false)} />}
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainMenu),
);
